module.exports = __webpack_public_path__ + "img/percent_bar.a0164b0f.svg";